<template>
    <div>
        <h3>活动列表</h3>
        <el-form :inline="true" size="mini">
            <el-form-item>
                <el-button type="primary" @click="$router.push('/activity/edit')" size="mini">新建</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" size="mini" v-loading="loading">
            <el-table-column prop="id" label="序号"></el-table-column>
            <el-table-column prop="title" label="标题">
                <template slot-scope="scope"><a :href="scope.row.url" target="_blank">{{scope.row.title}}</a></template>
            </el-table-column>
            <el-table-column prop="role" label="角色">
                <template slot-scope="scope">{{map.roles[scope.row.role]}}</template>
            </el-table-column>
            <el-table-column prop="priority" label="排序"></el-table-column>
            <el-table-column prop="updateTime" label="修改时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-dropdown size="medium" @command="handleCommand">
                        <span class="el-dropdown-link">
                            <i class="el-icon-menu" style="font-size: 24px;"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="">
                                <a :href="`/activity/edit?id=${scope.row.id}`" target="_blank">修改</a>
                            </el-dropdown-item>
                            <el-dropdown-item :command="{action: 'del', data: scope.row}">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
import map from '../../datamap'
import api from '../api'
const {
    activity,
} = api

export default {
    name: 'activities',
    data() {
        return {
            map,
            loading: true,
            list: [],
        }
    },
    components: {},
    computed: {},
    watch: {},
    methods: {
        async fetch() {
            this.loading = true
            let res = await activity.list()
            this.list = res.data.data
            this.loading = false
        },
        handleCommand(command) {
            let action = command.action;
            let data = command.data;
            switch (action) {
                case 'del':
                    this.delActivity(data);
                    break;
                default:
            }
        },
        delActivity(activityData) {
            this.$confirm('删除活动后不可恢复', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '再想想',
                type: 'warning'
            }).then(async() => {
                if (this.isSubmiting) return false;
                this.isSubmiting = true;
                console.log(activity);
                let {
                    data: {
                        code,
                        data,
                    }
                } = await activity.delete({id: activityData.id});
                if (code == 200) {
                    this.$message({
                        message: '删除成功',
                        type: 'success',
                    })
                    this.fetch()
                }
                this.isSubmiting = false;
            }).catch((e) => {
                console.log(e);
                this.isSubmiting = false;
                if (e === 'cancel') {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                } else {
                    this.$message({
                        type: 'error',
                        message: '操作失败'
                    });
                }
            });
        },
    },
    mounted() {
        this.fetch();
    },
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/activity/list.vue